import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import BaseTimelineEvent from 'common/utils/Workqueue/BaseTimelineEvent';

const ServiceAuthorizationCreateEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data');
  const eventChanges = get(timelineEvent, 'changes');
  const hasOriginalServiceAuthorization = !!eventChanges.find((change) => (
    change?.field_name === 'original_service_authorization_id'
  ));
  const employeeName = get(additionalData, 'employee_name');
  const recordShortId = eventChanges.find((change) => change?.field_name === 'short_id')?.to;

  const icon = hasOriginalServiceAuthorization ? 'IconPencil' : 'IconSubmit';
  const state = eventChanges.find((change) => change.field_name === 'state')?.to;
  const isUnilateralUpdate = hasOriginalServiceAuthorization && state === AUTHORIZATION_STATUSES.accepted;

  let message = '';
  if (isUnilateralUpdate) {
    message = `Updated by ${employeeName}`;
  } else if (hasOriginalServiceAuthorization) {
    message = `Update requested by ${employeeName}`;
  } else {
    message = `Submitted by ${employeeName}`;
  }
  const date = formatDate(timelineEvent.timestamp);
  const eventDetails = (
    <div className="text-12px text-dark-grey">
      Authorization ID: #{recordShortId}
    </div>
  );

  const formattedTimelineEvent = {
    icon,
    message,
    date,
    eventDetails,
    ...{ shouldDisplayIconDivider: hasOriginalServiceAuthorization },
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationCreateEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationCreateEvent;
